import { useEffect, useState } from "react";
import { PageHeader } from "../components/PageHeader";
import { useDocumentMeta } from "../hooks/use-document-meta";
import { useJsonLd } from "../hooks/use-json-ld";
import { ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import faqContent from "../content/pages/faq.json";
import settings from "../content/settings.json";

const FAQS = faqContent.items || [];
const META = faqContent.meta || {};
const CTA = faqContent.cta || {};

export default function FAQ() {
  useDocumentMeta({
    title: "FAQ grossiste fast-food — commande, livraison, échantillons",
    description:
      "Volumes, paiement, échantillons, traçabilité, livraison Île-de-France et France entière, références halal certifiées. Les réponses pour ouvrir un compte B2B Frites Dorées.",
    canonicalPath: "/faq",
  });
  useJsonLd("/faq", FAQS.length ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQS.map((f) => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a },
    })),
  } : null);
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const [open, setOpen] = useState(0);

  const phoneDisplay = settings.contact?.phone_display || "01 48 68 03 03";
  const phoneLink = settings.contact?.phone_link || "+33148680303";

  return (
    <main data-testid="faq-page" className="bg-[#050505]">
      <PageHeader
        kicker={META.kicker}
        title={
          <>
            {META.title}
            {META.title_highlight && (
              <>
                {" "}
                <br />
                <span className="text-[#FFC300]">{META.title_highlight}</span>
              </>
            )}
          </>
        }
        subtitle={META.subtitle}
      />

      <section className="px-6 md:px-10 lg:px-14 py-16 lg:py-24 max-w-4xl">
        {FAQS.map((f, i) => (
          <div key={i} className="border-t border-white/10" data-testid={`faq-item-${i}`}>
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-start md:items-center justify-between gap-4 py-6 md:py-8 text-left group"
              data-testid={`faq-toggle-${i}`}
            >
              <div className="flex items-start md:items-center gap-4 md:gap-6 flex-1">
                <span className="tag-label text-[#FFC300] shrink-0">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-display text-xl md:text-2xl lg:text-3xl uppercase tracking-tight leading-tight group-hover:text-[#FFC300] transition-colors">{f.q}</h3>
              </div>
              <ChevronDown size={22} className={`shrink-0 text-[#FFC300] transition-transform duration-400 ${open === i ? "rotate-180" : ""}`} />
            </button>
            <AnimatePresence initial={false}>
              {open === i && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                  className="overflow-hidden"
                >
                  <p className="font-body text-zinc-300 leading-relaxed text-base md:text-lg max-w-2xl pb-8 md:pl-14">{f.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
        <div className="border-t border-white/10"></div>
      </section>

      <section className="px-6 md:px-10 lg:px-14 py-20 lg:py-24 bg-[#FFC300] text-black">
        <h2 className="font-display text-3xl md:text-5xl uppercase tracking-tighter leading-none">
          {CTA.title || "Votre question"} <br /> {CTA.title_highlight || "n'est pas listée ?"}
        </h2>
        <a href={`tel:${phoneLink}`} className="btn-primary !bg-black !text-[#FFC300] hover:!bg-white hover:!text-black mt-8 inline-flex">
          {CTA.label_prefix || "Nous appeler au"} {phoneDisplay}
        </a>
      </section>
    </main>
  );
}
